/* ÉclatDent : « Vus récemment » (03/11/2026, 50 améliorations, point 13). Snippet : snippets/ed-vus-recemment.liquid.
   Mémorise les fiches vues (handles, 12 au plus) dans le stockage local du navigateur ; affiche les 4 dernières autres que la
   page courante, avec prix et disponibilité relus en direct à l'approche du bloc. Sans stockage disponible : rien. */
(() => {
  const box = document.querySelector('[data-ed-vus]');
  if (!box) return;
  const CLE = 'ed-vus';
  const lire = () => { try { const v = JSON.parse(localStorage.getItem(CLE) || '[]'); return Array.isArray(v) ? v.filter((h) => typeof h === 'string') : []; } catch (e) { return null; } };
  let liste = lire();
  if (liste === null) return;
  const courant = box.dataset.courant || '';
  if (courant) {
    liste = [courant, ...liste.filter((h) => h !== courant)].slice(0, 12);
    try { localStorage.setItem(CLE, JSON.stringify(liste)); } catch (e) { /* stockage plein ou refusé */ }
  }
  const autres = liste.filter((h) => h !== courant).slice(0, 4);
  if (!autres.length) return;

  const racine = (box.dataset.racine || '/').replace(/\/?$/, '/');
  const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  const prix = (c) => { try { return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: cur }).format(c / 100); } catch (e) { return (c / 100).toFixed(2); } };
  const img = (u) => (u ? (u.startsWith('//') ? 'https:' + u : u) + (u.includes('?') ? '&' : '?') + 'width=128' : '');

  const afficher = () => {
    Promise.all(autres.map((h) => fetch(racine + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null)).catch(() => null)))
      .then((prods) => {
        const ok = prods.filter(Boolean);
        // les fiches disparues (produit retiré) sont oubliées
        const vivants = new Set(ok.map((p) => p.handle));
        const nettoye = liste.filter((h) => h === courant || vivants.has(h) || !autres.includes(h));
        if (nettoye.length !== liste.length) { try { localStorage.setItem(CLE, JSON.stringify(nettoye)); } catch (e) { /* rien */ } }
        if (!ok.length) return;
        const zone = box.querySelector('[data-ed-vus-liste]');
        ok.forEach((p) => {
          const a = document.createElement('a');
          a.className = 'ed-vus-carte';
          a.href = racine + 'products/' + p.handle;
          const im = document.createElement('img');
          im.src = img(p.featured_image || '');
          im.alt = '';
          im.width = 64; im.height = 64; im.loading = 'lazy';
          const txt = document.createElement('span');
          const t = document.createElement('span');
          t.className = 'ed-vus-t';
          t.textContent = p.title;
          const pr = document.createElement('span');
          pr.className = 'ed-vus-p';
          pr.textContent = p.available ? prix(p.price) : (box.dataset.tSoldout || '');
          txt.append(t, pr);
          a.append(im, txt);
          zone.appendChild(a);
        });
        box.hidden = false;
      });
  };
  if ('IntersectionObserver' in window) {
    // le bloc est masqué (hidden) : on observe le pied de page, juste dessous
    const repere = document.querySelector('footer') || box;
    const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { io.disconnect(); afficher(); } }, { rootMargin: '600px 0px' });
    io.observe(repere);
  } else afficher();
})();
